import { addDays, format, addMonths, startOfWeek, endOfWeek } from 'date-fns';

export const formatDateForInput = (date: Date, view: string) => {
	if (view === 'month' || view === 'agenda') {
		return format(date, 'yyyy-MM'); // For month view
	} else if (view === 'week' || view === 'day') {
		return format(date, 'yyyy-MM-dd'); // For week or day view
	}
};

export const formatNavigation = (date: Date, view: string) => {
	let formattedPrev: string | JSX.Element;
	let formattedNext: string | JSX.Element;
	let todayText: string;

	switch (view) {
		case 'month':
			formattedPrev = format(addMonths(date, -1), 'MMM');
			formattedNext = format(addMonths(date, 1), 'MMM');
			todayText = 'This Month';
			break;
		case 'day':
			formattedPrev = format(addDays(date, -1), 'yyyy-MM-dd');
			formattedNext = format(addDays(date, 1), 'yyyy-MM-dd');
			todayText = 'Today';
			break;
		case 'week':
			const startOfWeekDate = startOfWeek(date);
			const endOfWeekDate = endOfWeek(date);
			formattedPrev = format(startOfWeek(startOfWeekDate, { weekStartsOn: 0 }), 'MMM dd');
			formattedNext = format(endOfWeek(endOfWeekDate), 'MMM dd');
			todayText = `Today`;
			break;
		case 'agenda':
			formattedPrev = format(addMonths(date, -1), 'MMM yyyy');
			formattedNext = format(addMonths(date, 1), 'MMM yyyy');
			todayText = 'This Month';
			break;
		default:
			formattedPrev = '';
			formattedNext = '';
			todayText = 'Today';
			break;
	}
	return { formattedPrev, formattedNext, todayText };
};
